// extracted by mini-css-extract-plugin
export default {"solutions":"Solutions_solutions__RBIMf"};